// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__ng8zL","navbar__actions-box":"navbar_navbar__actions-box__42jLc","navbar__actions-box__action-icon":"navbar_navbar__actions-box__action-icon__AKxzf"};